import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Axios from "axios";

// CSS
import "../../assets/css/components/sidebar.css";

function Sidebar() {
  const [authData, setAuthData] = useState({});
  const [openMenu, setOpenMenu] = useState(null);
  const location = useLocation();

  const company = localStorage.getItem("company");
  const path = location.pathname;

  // รวม config เมนูไว้ที่เดียว (ทำให้แก้/เพิ่มเมนูง่าย)
  const menuConfig = [
    {
      key: "purchase",
      label: "จัดซื้อสินค้า",
      icon: "fas fa-shopping-cart",
      activePaths: [
        "/purchase",
        "/deposit-document",
        "/purchase-request",
        "/purchase-order",
        "/product-receipt",
        "/payment-voucher",
        "/purchase-list",
      ],
      items: [
        { href: "/deposit-document", label: "ใบมัดจำ" },
        { href: "/purchase-request", label: "ใบขอซื้อ" },
        { href: "/purchase-order", label: "ใบสั่งซื้อ" },
        { href: "/product-receipt", label: "ใบรับสินค้า" },
        { href: "/payment-voucher", label: "ใบสำคัญจ่าย" },
      ],
    },
    {
      key: "warehouse",
      label: "คลังสินค้า",
      icon: "fas fa-building",
      activePaths: [
        "/warehouse",
        "/warehouse-stock",
        "/treasury-documents",
        "/remain-stock",
      ],
      items: [
        { href: "/warehouse-stock", label: "สต็อกคลังสินค้า" },
        { href: "/treasury-documents", label: "จัดการเอกสารคลัง" },
        {
          href: "/remain-stock",
          label: "ตรวจสอบคืนถัง",
          showWhen: () => company === "1",
        },
      ],
    },
    {
      key: "borrow",
      label: "ใบยืม-ใบเบิก",
      icon: "fas fa-retweet",
      activePaths: [
        "/borrow-withdrawal",
        "/bill-of-lading",
        "/icebox",
        "/technical-equip-form",
        "/office-equip-form",
      ],
      items: [
        { href: "/bill-of-lading", label: "ใบเบิก Vansale" },
        {
          href: "/icebox",
          label: "ใบยืมสินค้า",
          showWhen: () => company === "2",
        },
        { href: "/technical-equip-form", label: "ใบเบิกอุปกรณ์ช่าง" },
        { href: "/office-equip-form", label: "ใบเบิกวัสดุใช้ภายใน" },
      ],
    },
    {
      key: "sell",
      label: "ขายสินค้า",
      icon: "fas fa-tags",
      activePaths: [
        "/sellproducts",
        "/quotation",
        "/order-product",
        "/billofsale",
        "/picking-list",
        "/product-delivery",
      ],
      items: [
        { href: "/quotation", label: "ใบเสนอราคา (QT)" },
        { href: "/order-product", label: "ออเดอร์สินค้า (OD)" },
        { href: "/billofsale", label: "ใบขาย (SO)" },
        { href: "/picking-list", label: "Picking List (PK)" },
        { href: "/product-delivery", label: "ใบส่งสินค้าผลิต (ST)" },
      ],
    },
    {
      key: "account",
      label: "งานบัญชี",
      icon: "fas fa-credit-card",
      activePaths: ["/account", "/payment-stock", "/bill", "/invoice", "/tax"],
      items: [
        { href: "/payment-stock", label: "ตรวจสอบค้างจ่าย" },
        { href: "/bill", label: "ใบวางบิล (BI)" },
        { href: "/invoice", label: "ใบกำกับภาษี (INV)" },
        { href: "/tax", label: "หนังสือหัก ณ ที่จ่าย" },
      ],
    },
    {
      key: "initial",
      label: "ข้อมูลตั้งต้น",
      icon: "fas fa-folder",
      activePaths: [
        "/initialdata",
        "/creditor",
        "/APtype",
        "/debtor",
        "/ARtype",
        "/company",
        "/dept",
        "/position",
        "/employee",
        "/car",
        "/transType",
        "/docType",
        "/tbsetwh",
        "/tbsetitem",
        "/prodgroup",
        "/brand",
        "/prodcategory",
        "/unit",
        "/itmtype",
        "/tbsetbank",
        "/deliveryCustomerInfo",
        "/deliveryCarInfo",
      ],
      items: [
        { href: "/creditor", label: "ข้อมูลเจ้าหนี้" },
        { href: "/APtype", label: "ข้อมูลประเภทเจ้าหนี้" },
        { href: "/debtor", label: "ข้อมูลลูกหนี้" },
        { href: "/ARtype", label: "ข้อมูลประเภทลูกหนี้" },
        { href: "/company", label: "ข้อมูลบริษัท" },
        { href: "/dept", label: "ข้อมูลแผนก" },
        { href: "/position", label: "ข้อมูลตำแหน่ง" },
        { href: "/employee", label: "ข้อมูลพนักงาน" },
        { href: "/car", label: "ข้อมูลรถ" },
        { href: "/transType", label: "ข้อมูลวิธีการขนส่ง" },
        { href: "/docType", label: "ข้อมูลประเภทเอกสาร" },
        { href: "/tbsetwh", label: "ข้อมูลคลังสินค้า" },
        { href: "/tbsetitem", label: "ข้อมูลสินค้า" },
        // ✅ แก้ให้ active ถูก path และ href ถูกหน้า
        { href: "/prodgroup", label: "ข้อมูลกลุ่มสินค้า" },
        { href: "/brand", label: "ข้อมูลแบรนด์สินค้า" },
        { href: "/prodcategory", label: "ข้อมูลหมวดหมู่สินค้า" },
        { href: "/unit", label: "ข้อมูลหน่วยนับ" },
        { href: "/itmtype", label: "ข้อมูลประเภทค่าใช้จ่าย" },
        { href: "/tbsetbank", label: "ข้อมูลธนาคาร" },
        { href: "/deliveryCustomerInfo", label: "ข้อมูลลูกค้าผูกสายส่ง" },
        { href: "/deliveryCarInfo", label: "ข้อมูลรถผูกสายส่ง" },
      ],
    },
  ];

  useEffect(() => {
    initialize();
  }, []);

  // ✅ เข้าหน้าไหน ให้เปิดหมวดนั้นอัตโนมัติ
  useEffect(() => {
    const found = menuConfig.find((m) => m.activePaths.includes(path));
    setOpenMenu(found ? found.key : null);
  }, [path]); // eslint-disable-line

  const initialize = async () => {
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/authen`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            key: process.env.REACT_APP_ANALYTICS_KEY,
          },
        },
      );

      if (response.data.status === "OK") {
        setAuthData(response.data.decoded);
      } else {
        window.location.replace("/login");
      }
    } catch (error) {
      window.location.replace("/login");
    }
  };

  const toggleMenu = (key) => {
    setOpenMenu((prev) => (prev === key ? null : key)); // เปิดทีละหมวด
  };

  return (
    <>
      <div className="sidebar" data-background-color="dark">
        <div className="sidebar-wrapper scrollbar scrollbar-inner">
          {/* Logo */}
          <div className="sidebar-logo">
            <div className="logo-header mt-4" data-background-color="dark">
              <button
                data-bs-toggle="modal"
                data-bs-target="#profileModal"
                className="logo"
                style={{
                  background: "none",
                  border: "none",
                  padding: "2.5rem",
                }}
              >
                <img
                  src={
                    company === "1"
                      ? "assets/img/logo_water.jpg"
                      : "assets/img/logo_ice.jpg"
                  }
                  alt="Logo"
                  className="navbar-brand"
                  width={100}
                  style={{
                    borderRadius: "30%",
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.5)",
                  }}
                />
              </button>
            </div>
          </div>

          <div className="sidebar-content">
            <ul className="nav nav-secondary">
              {/* User Information */}
              <li className="nav-item topbar-user dropdown hidden-caret">
                <center>
                  <button
                    style={{
                      marginLeft: "10px",
                      marginBottom: "10px",
                      textAlign: "center",
                      color: "#EF6C00",
                      display: "flex",
                      alignItems: "center",
                    }}
                    className="btn dropdown-toggle profile-pic"
                    data-bs-toggle="modal"
                    data-bs-target="#profileModal"
                  >
                    <p className="text-white" style={{ margin: 0 }}>
                      <strong>{authData.Emp_Name || ""}</strong>
                    </p>
                    <i
                      className="fa fa-chevron-down ms-2 text-white"
                      style={{ fontSize: "10px" }}
                    />
                  </button>
                  <p
                    className="text-white text-center"
                    style={{ marginTop: "-20px" }}
                  >
                    <strong>( {authData.Comp_ShortName || ""} )</strong>
                  </p>
                </center>
              </li>

              {/* Dashboard */}
              <li className={`nav-item ${path === "/" ? "active" : ""}`}>
                <a href="/" className="collapsed">
                  <i className="fas fa-home" style={{ color: "white" }} />
                  <p>Dashboard</p>
                </a>
              </li>

              {/* Reports */}
              <li
                className={`nav-item ${
                  [
                    "/reports",
                    "/sales-report",
                    "/inventory-movement-report",
                    "/stock-balance-report",
                    "/loan-crate-report",
                    "/deposit-report",
                    "/overdue-loan-crate-report",
                    "/receivables-report",
                    "/payables-report",
                    "/bill-report-new",
                    "/monthly-expense-summary-report",
                  ].includes(path)
                    ? "active"
                    : ""
                } text-white`}
              >
                <a href="/reports" className="collapsed">
                  <i className="fas fa-file" style={{ color: "white" }} />
                  <p>รายงาน</p>
                </a>
              </li>

              {/* ✅ เมนูหลักแบบพับ/กาง (เปิดทีละหมวด) */}
              {menuConfig.map((menu) => {
                const isActive = menu.activePaths.includes(path);
                const isOpen = openMenu === menu.key;

                return (
                  <li
                    key={menu.key}
                    className={`nav-item ${isActive ? "active" : ""} text-white`}
                  >
                    <a
                      href="#"
                      className="collapsed"
                      aria-expanded={isOpen}
                      onClick={(e) => {
                        e.preventDefault();
                        toggleMenu(menu.key);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <i className={menu.icon} style={{ color: "white" }} />
                      <p>{menu.label}</p>
                      <span className="caret" />
                    </a>

                    <div
                      className={`collapse ${isOpen ? "show" : ""}`}
                      id={`menu-${menu.key}`}
                    >
                      <ul className="nav nav-collapse">
                        {menu.items
                          .filter((it) => (it.showWhen ? it.showWhen() : true))
                          .map((it) => (
                            <li
                              key={it.href}
                              className={`nav-item ${path === it.href ? "active" : ""}`}
                            >
                              <a href={it.href}>
                                <span className="sub-item">{it.label}</span>
                              </a>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="profileModal"
        tabIndex="-1"
        aria-labelledby="profileModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="profileModalLabel">
                User Profile
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="user-box">
                <div className="u-text">
                  <h4>{authData.Emp_Name}</h4>
                  <p className="text-muted">{authData.Dept_Name || ""}</p>
                  <p className="text-muted">{authData.PST_Name || ""}</p>
                  <p className="text-muted">{authData.Comp_Name_TH || ""}</p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                onClick={() => window.location.replace("/login")}
                className="btn btn-danger w-100"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
